var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M23,25.3c1,0.8,2.5,0.8,2.9-0.6l0.7-2.1c0-0.1,0.1-0.2,0.1-0.4h-7.6L23,25.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M24.6,10.6V9.4c0-1-0.8-1.8-1.8-1.8c0,0-0.1,0-0.1,0c-1,0-1.8,0.8-1.8,1.8v1c-5.5,0.6-9.8,5.2-10,10.8H9.2 c-0.3,0-0.5,0.2-0.5,0.5c0,0.2,0.3,0.4,0.5,0.4h4.4c-0.1,0.2-0.2,0.4-0.2,0.6c0.1,0.4,0.2,0.7,0.5,1l5.5,4.4c1.6,1.3,3,2.8,4.2,4.4 l0.4,0.6l-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.3,0.1,0.4l2.6,3.2h0.7l5.4-4c0.2-0.2,0.2-0.5,0.1-0.7l-2.3-3.1 c-0.1-0.2-0.4-0.3-0.5-0.1c0,0,0,0-0.1,0h-0.3c-0.5-2-0.5-4,0.1-6c0.1-0.4,0-0.9-0.2-1.3h6.7c0.2,0,0.5-0.2,0.5-0.4 c0-0.2-0.3-0.4-0.5-0.4h-1.6C33.9,15.9,29.9,11.4,24.6,10.6z M21.8,9.4c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,1,0.9v1h-1.9V9.4z  M29.6,30.4l1.8,2.4l-4.7,3.5l-2.1-2.4L29.6,30.4z M28.4,30.1l-3.6,2.6l-0.4-0.6c-1.3-1.7-2.7-3.3-4.4-4.6l-5.5-4.4 c-0.2-0.2-0.2-0.5,0-0.6c0.1-0.1,0.4-0.1,0.5,0l6.2,5.3c0.2,0.2,0.5,0.2,0.6,0c0.2-0.2,0.2-0.5,0-0.7l-4.7-4 c-0.2-0.2-0.2-0.5,0-0.7c0,0,0.1-0.1,0.1-0.1h0.6l4.6,3.8c1.4,1.1,3.8,1,4.4-1.1l0.7-2.1c0-0.2,0.3-0.4,0.5-0.4 c0.3,0.1,0.5,0.4,0.4,0.7C27.7,25.4,27.7,27.8,28.4,30.1z M26.6,22.6l-0.7,2.1c-0.4,1.4-1.9,1.4-2.9,0.6l-3.9-3.1h7.6 C26.7,22.4,26.6,22.4,26.6,22.6z M33.2,21.3H11.8c0.1-2.6,1.2-5,3-6.9c2.1-2.1,5-3.1,8-3C28.4,11.3,32.9,15.7,33.2,21.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M26.7,36.3l4.7-3.5l-1.8-2.4l-5,3.5L26.7,36.3z M26.8,33.6c0.4,0,0.6,0.2,0.6,0.5c0,0.1,0,0.2,0,0.2 c-0.1,0.3-0.3,0.4-0.6,0.4c-0.3,0-0.5-0.2-0.5-0.6C26.3,33.9,26.5,33.6,26.8,33.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M28,22.4c-0.2,0-0.5,0.2-0.5,0.4l-0.7,2.1c-0.6,2.1-3,2.2-4.4,1.1l-4.6-3.8h-0.6c0,0-0.1,0.1-0.1,0.1 c-0.2,0.2-0.2,0.5,0,0.7l4.7,4c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.2-0.4,0.2-0.6,0L15,22.4c-0.1-0.1-0.4-0.1-0.5,0 c-0.2,0.1-0.2,0.4,0,0.6l5.5,4.4c1.7,1.3,3.1,2.9,4.4,4.6l0.4,0.6l3.6-2.6c-0.7-2.3-0.7-4.6,0-6.9C28.5,22.8,28.3,22.5,28,22.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M23.7,9.4c-0.1-0.5-0.5-0.9-1-0.9c-0.5,0-0.9,0.4-0.9,0.9v1h1.9V9.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M22.8,11.4c-3-0.1-5.9,0.9-8,3c-1.8,1.9-2.9,4.3-3,6.9h21.4C32.9,15.7,28.4,11.3,22.8,11.4z M13.5,20.1 C13.5,20.1,13.5,20.1,13.5,20.1c-0.3-0.1-0.5-0.3-0.4-0.6c1-4,4.5-6.9,8.6-7.1c0.2,0,0.5,0.2,0.5,0.4c0,0.3-0.2,0.5-0.5,0.5 c-3.7,0.2-6.8,2.8-7.7,6.4C14,20.1,13.7,20.1,13.5,20.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M21.7,13.4c0.3,0,0.5-0.2,0.5-0.5c0-0.2-0.3-0.4-0.5-0.4c-4.1,0.2-7.6,3.1-8.6,7.1 c-0.1,0.3,0.1,0.5,0.4,0.6c0,0,0,0,0,0c0.2,0,0.5-0.1,0.5-0.4C14.9,16.2,18,13.6,21.7,13.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M26.8,34.8c0.3,0.1,0.5-0.1,0.6-0.4c0-0.1,0-0.2,0-0.2c0-0.3-0.2-0.5-0.6-0.5c-0.3,0-0.5,0.2-0.5,0.5 C26.3,34.6,26.5,34.8,26.8,34.8z"
}));

function SvgCatering(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatering);
export default __webpack_public_path__ + "static/media/catering.f1cad7efdeaad8cad93a685e0f9e9b85.svg";
export { ForwardRef as ReactComponent };